define(function (require) {

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    lpTag.PostSurvey = function () {

        this.POLLING_TIME_IN_SEC = 600;
        this.SERVICE_NAME = {
            ACCOUNT_CONFIG: "post_surveys"
        };

        this.applicationType = "PostSurvey";

        this.logger = WebAgentLogger.getLogger(this.applicationType);

        this._initApi();
    };

    lpTag.PostSurvey.prototype = {

        _initApi: function () {
            if (lpTag.WebAgent.logicController.hasMessagingSurvey()) {
                this._initAccountConfigApi();
            }
        },

        _initAccountConfigApi: function () {
            this.getPostSurvey = function (reqObj) {
                var postSurveyCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getPostSurveyCollection);

                //if we're running after the first fetch - get the current data so we don't wait for the next fetch
                if (postSurveyCollection.getFetchState() === postSurveyCollection.FetchStateEnum.SUCCESS) {
                    reqObj.success({body: postSurveyCollection.toJSON()});
                }
                else {
                    //bind to changes on the required properties in the data module
                    postSurveyCollection.listenToOnce(postSurveyCollection, "fetch:success", function() {
                        reqObj.success({body: postSurveyCollection.toJSON()});
                    });
                }
            };
        }
    };

    return lpTag.PostSurvey;
});
